var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('api-post-button',{attrs:{"classes":_vm.btnClass,"confirm":"Are you sure you want to send a reminder to this participant?","disabled":_vm.disabled,"endPoint":("/api/v0/participants/" + (_vm.participant.id) + "/prepay/invite"),"icon-class":_vm.iconClass,"method":"post","params":{
        email: _vm.participant.email,
        first_name: _vm.participant.first_name,
        last_name: _vm.participant.last_name,
        message: _vm.message,
    },"tag":"button","text":_vm.btnText},on:{"error":_vm.reminderCouldntSend,"response":_vm.reminderSent}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2526506","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/Participants/Utilities/Buttons/SendPrepayReminderButton.vue
// module id = 2136
// module chunks = 1